module.exports = __webpack_public_path__ + "img/clipboard.1ea1aff7.svg";